import * as UI     from '../ui';
import { connect } from 'react-redux';
import React       from 'react';

export default connect(
  state => ({
    isInProgress: UI.isInProgress(state)
  })
)(ProgressIndicator);


function ProgressIndicator({ isInProgress }) {
  if (!isInProgress)
    return null;

  return (
    <React.Fragment>
      <div className="preloader-backdrop"></div>
      <div className="preloader-modal">
        <div className="preloader color-broadly"></div>
      </div>
    </React.Fragment>
  );
}
